import { Box, Button, MenuItem, TextField } from '@mui/material'
import { MRT_Column, MRT_RowData } from 'material-react-table'
import React from 'react'

import { buttonSx, Field, FieldLabel, inputSx } from 'src/utils/views'

type CustomTableColumnFilterProps<T extends MRT_RowData> = {
    column: MRT_Column<T>
}

type FilterMode = 'equals' | 'empty' | 'not_empty'

type FilterValue = {
    type: FilterMode
    value?: string
}

export const CustomTableColumnFilter = <T extends MRT_RowData>({ column }: CustomTableColumnFilterProps<T>) => {
    const fv = column.getFilterValue() as FilterValue
    const [mode, setMode] = React.useState<FilterMode>((fv && fv.type) || 'equals')

    const inputRef = React.useRef<HTMLInputElement>(null)

    const applyFilter = () => {
        const value = inputRef.current?.value || ''
        column.setFilterValue({ type: mode, value })
    }

    const fieldId = `col-filter-${column.id}`

    return (
        <Box sx={{ p: '12px', display: 'flex', flexDirection: 'column', gap: '12px', minWidth: 232 }}>
            <Field>
                <FieldLabel htmlFor={`${fieldId}-modo`}>Critério</FieldLabel>
                <TextField
                    id={`${fieldId}-modo`}
                    select
                    size="small"
                    value={mode}
                    onChange={(e) => setMode(e.target.value as FilterMode)}
                    sx={inputSx}
                    fullWidth
                >
                    <MenuItem value="equals">Igual</MenuItem>
                    <MenuItem value="empty">Somente vazios</MenuItem>
                    <MenuItem value="not_empty">Somente não vazios</MenuItem>
                </TextField>
            </Field>

            {mode === 'equals' && (
                <Field>
                    <FieldLabel htmlFor={`${fieldId}-valor`}>Valor</FieldLabel>
                    <TextField
                        id={`${fieldId}-valor`}
                        size="small"
                        defaultValue={(fv && fv.value) || ''}
                        inputRef={inputRef}
                        placeholder="Filtro..."
                        onKeyDown={(evt) => evt.code === 'Enter' && applyFilter()}
                        sx={inputSx}
                        fullWidth
                    />
                </Field>
            )}

            <Button sx={{ ...buttonSx('primary'), width: '100%' }} onClick={applyFilter}>
                Aplicar
            </Button>
        </Box>
    )
}
